// ==========================================================================
// useAnalytics - Auto user identification on login/logout
// ==========================================================================

import { useEffect, useRef } from 'react';
import { useUser } from '@/hooks/useUser';
import { identifyUser, resetMixpanel } from '@/lib/mixpanel';

export function useAnalytics(): void {
  const { data: user } = useUser();
  const prevUserIdRef = useRef<number | null>(null);

  // Identify user when loaded, reset when cleared
  useEffect(() => {
    if (user) {
      identifyUser(user);
      prevUserIdRef.current = user.id;
    } else if (!user && prevUserIdRef.current !== null) {
      resetMixpanel();
      prevUserIdRef.current = null;
    }
  }, [user]);
}
